// extracted by mini-css-extract-plugin
export default {"spinnerPosition":"gScJ7","errorTemplate":"psNi8","errorDetails":"pXVO6","logoNotFound":"MPP3l"};